module.exports = __webpack_public_path__ + "img/button_delete_template.3b80f2c2.svg";